/**
 * Cliente HTTP para los endpoints DEV de colisión de casas.
 *
 * Solo funciona si el server corre en DEV (NODE_ENV !== production).
 * El server filtra por el guard interno del router (`__dev/houses`).
 */

import type { HouseBlockOffset } from '@shared/world/houseData';
import { SERVER_CONFIG } from '@shared/constants';

const SERVER_BASE =
  (import.meta.env.VITE_SERVER_HTTP_URL as string | undefined) ??
  `http://${window.location.hostname}:${SERVER_CONFIG.PORT}`;

const BASE = `${SERVER_BASE}/__dev/houses`;

/** Catálogo completo: `houseId → offsets bloqueados`. */
export async function listHouseCollision(): Promise<Record<string, HouseBlockOffset[]>> {
  const res = await fetch(`${BASE}/list`);
  if (!res.ok) throw new Error(`list failed: ${res.status}`);
  return (await res.json()) as Record<string, HouseBlockOffset[]>;
}

/** Guarda (upsert) la lista de bloqueos de una casa. */
export async function saveHouseCollision(
  houseId: string,
  blocks: HouseBlockOffset[]
): Promise<void> {
  const res = await fetch(`${BASE}/save`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ houseId, blocks }),
  });
  if (!res.ok) {
    const err = (await res.json().catch(() => ({ error: res.statusText }))) as { error?: string };
    throw new Error(err.error ?? `save failed: ${res.status}`);
  }
}
